// PERF: Extracted from theme.liquid to reduce inline script size
// Search functionality initialization
(function() {
  'use strict';

  // Wait for jQuery to be available
  function initSearch() {
    if (typeof jQuery === 'undefined') {
      setTimeout(initSearch, 50);
      return;
    }

    const $ = jQuery;

    $(document).ready(function () {
      // Target the input box with a specific ID

      $('body').on('click', '.cs-btn-primary', function () {
        var isMobile = window.innerWidth <= 768;
        if (!isMobile) {
          // Desktop
          var b = $('.desktop-search-input').val();
          if (b !== '') {
            window.location.href = '/search?q=' + b;
          }
        } else {
          // Mobile
          var a = $('.mobile-search-input').val();
          if (a !== '') {
            window.location.href = '/search?q=' + a;
          }
        }
      });
      $('#desktop-search').on('input keypress', function (event) {
        // Check if the key pressed is the "Enter" key (key code 13)
        var a = $(this).val();
        setTimeout(function () {
          const storefrontAccessToken = '3d09f5c025e6999af0d6970dbc1c0ca2';
          const storeDomain = 'stadiumstreettees.myshopify.com';
          const searchQuery = a;

          if (!searchQuery) {
            //alert('Please enter a search term.');
          } else {
            $.ajax({
              url: `https://${storeDomain}/api/2023-10/graphql.json`,
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-Shopify-Storefront-Access-Token': storefrontAccessToken,
              },
              data: JSON.stringify({
                query: `
          {
          search(query: "${searchQuery}", first: 1) {
            totalCount
          }
          }
          `,
              }),
              success: function (response) {
                const totalCount = response.data.search.totalCount;
                $('.cs-serch-count').text('(' + totalCount + ')');
              },
              error: function (xhr, status, error) {
                //console.error('Error:', error);
              },
            });
          }
        }, 1000);
        if (event.which == 13) {
          $('#MobileQuickAddDrawer').remove();
          $('quick-add').remove();
          $('.cs-cs-search-desktop').trigger('click');
          event.preventDefault();
        }
      });
      $('.mobile-search-input').on('input keypress', function (event) {
        // Check if the key pressed is the "Enter" key (key code 13)
        var a = $(this).val();
        setTimeout(function () {
          //$('.cs-btn-primary').attr('href', '');
          //$('.cs-btn-primary').attr('href', '/search?q=' + a);
        }, 800);
        if (event.which == 13) {
          $('#MobileQuickAddDrawer').remove();
          $('quick-add').remove();
          $('#mobile-search .cs-cs-search').trigger('click');
          event.preventDefault();
        }
      });
    });

    // Parse the JSON from the script tag
    const productJSONEl = document.getElementById('ProductJSON');
    if (productJSONEl) {
      try {
        let productData = JSON.parse(productJSONEl.textContent);
        // Delete the tags property
        delete productData.tags;
        // Convert back to JSON and update the script tag's content
        productJSONEl.textContent = JSON.stringify(productData);
      } catch (e) {
        // Silently fail if ProductJSON doesn't exist or is invalid
      }
    }
  }

  // Start initialization
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSearch);
  } else {
    initSearch();
  }
})();
